import { Dispatch, SetStateAction } from 'react';
import KeyboardDoubleArrowLeftRoundedIcon from '@mui/icons-material/KeyboardDoubleArrowLeftRounded';
import KeyboardDoubleArrowRightRoundedIcon from '@mui/icons-material/KeyboardDoubleArrowRightRounded';

export enum PageSizeOptions {
    SMALL = 10,
    MEDIUM = 20,
    LARGE = 30,
}

interface Props {
    pageNumber: number;
    setPageNumber: Dispatch<SetStateAction<number>>;
    pageSize: number;
    setPageSize: Dispatch<SetStateAction<number>>;
    ultimaPagina: number;
}

export function PaginationButtons({ pageNumber, setPageNumber, pageSize, setPageSize, ultimaPagina }: Props) {

    const handlePageSize = (newPageSize: number, currentPageSize: number) => {
        if(newPageSize == currentPageSize) return;
        setPageSize(newPageSize);
    }

    const disablePreviousPageButton = pageNumber - 1 < 1;
    const disableNextPageButton = pageNumber + 1 > ultimaPagina;

    return (
        <div className="flex gap-x-4 my-3 ">

            <div className="flex gap-x-[2px] items-center border-2 border-gray-300 rounded-lg w-fit h-[30px] px-[2px]">

                <div 
                    className={`
                    h-[20px] w-[20px] flex justify-center items-center select-none rounded text-sm
                    ${pageSize == PageSizeOptions.SMALL ? "bg-gray-200 m-[1px]" : "cursor-pointer"}`}
                    onClick={() => handlePageSize(PageSizeOptions.SMALL, pageSize)}>
                    <p className={`${pageSize == PageSizeOptions.SMALL ? "font-bold" : ""} `}>{PageSizeOptions.SMALL}</p>
                </div>

                <div className={`
                    h-[20px] w-[20px] flex justify-center items-center select-none text-sm rounded
                    ${pageSize == PageSizeOptions.MEDIUM ? "bg-gray-200 m-[1px]" : "cursor-pointer"}`}
                    onClick={() => handlePageSize(PageSizeOptions.MEDIUM, pageSize)}>

                    <p className={`${pageSize == PageSizeOptions.MEDIUM ? "font-bold" : ""} `}>{PageSizeOptions.MEDIUM}</p>

                </div>

                <div className={`
                    h-[20px] w-[20px] flex justify-center items-center select-none text-sm rounded
                    ${pageSize == PageSizeOptions.LARGE ? "bg-gray-200 m-[1px]" : "cursor-pointer"}`}
                    onClick={() => handlePageSize(PageSizeOptions.LARGE, pageSize)}>
                    <p className={`${pageSize == PageSizeOptions.LARGE ? "font-bold" : ""} `}>{PageSizeOptions.LARGE}</p>
                </div>

            </div>

            <div className="flex items-center border-2 border-gray-300 rounded-lg w-fit h-[30px]">
                <div
                    className={`w-[25px] h-full rounded-l-[6px] flex justify-center items-center ${disablePreviousPageButton ? "cursor-not-allowed opacity-50" : "hover:bg-gray-200 cursor-pointer"}`}
                    onClick={() => {
                        if(disablePreviousPageButton) return;
                        setPageNumber(pageNumber - 1);
                    }}>
                    <KeyboardDoubleArrowLeftRoundedIcon sx={{
                        height: 20,
                        width: 20,
                    }}/>
                </div>

                <div className="w-[25px] flex justify-center items-center select-none">
                    <p className="font-bold text-sm">{pageNumber}</p>
                </div>

                <div
                    className={`w-[25px] m-0 p-0 h-full rounded-r-[6px] flex justify-center items-center ${disableNextPageButton ? "cursor-not-allowed opacity-50" : "hover:bg-gray-200 cursor-pointer"}`}
                    onClick={() => {
                        if(disableNextPageButton) return;
                        setPageNumber(pageNumber + 1);
                    }}>
                    <KeyboardDoubleArrowRightRoundedIcon sx={{
                        height: 20,
                        width: 20,
                    }}/>
                </div>
            </div>

        </div>
    );
}